import iotDeviceFeatureConfigService from '../../../../services/iotDevice/iotDeviceFeatureConfigService';
import iotDeviceGlobalConfigService from '../../../../services/iotDevice/iotDeviceGlobalConfigService';
import iotDeviceSettingsService from '../../../../services/iotDevice/iotDeviceSettingsService';

const useVapeCloudModeEnabled = (iotDevice) => {
    const isGlobalVapeCloudSize = iotDeviceGlobalConfigService.isGlobalVapeCloudSize(iotDevice);
    const isFeatureVapeCloudSize = iotDeviceFeatureConfigService.isVapeCloudModeEnabled();

    const isVapeCloudSizeEnabled = iotDeviceSettingsService.isSettingAvailable(
        iotDevice,
        isGlobalVapeCloudSize,
        isFeatureVapeCloudSize
    );

    return isVapeCloudSizeEnabled;
};

export default useVapeCloudModeEnabled;
